import { css } from "styled-components";
import token from "styled-token";
import { StyledDropdownIcon } from "../../components/Dropdown/DropdownIcon";
import { spaceMixin } from "../spaceMixin";
/** @class PropertyCardActionAreaMixin */

/** @method */

export var PropertyCardActionAreaMixin = function PropertyCardActionAreaMixin(props) {
  return token("icons.sizes.sm", function (iconSize) {
    return css(["grid-area:actions;display:grid;grid-auto-flow:column;grid-column-gap:", ";justify-content:end;", " > svg{width:", "px;height:", "px;}"], spaceMixin("sm")(props), StyledDropdownIcon, iconSize, iconSize);
  });
};